// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GTv_","controls":"styles_controls__2fy0I","charLimit":"styles_charLimit__2mHe4","input":"styles_input__1GJZV","send":"styles_send__7RNBM"};